import type { Landmark } from '../types';
import { IDX } from '../constants';

const LEFT_CHAIN = [IDX.L_EAR, IDX.L_SHO, IDX.L_HIP, IDX.L_ANK] as const;
const RIGHT_CHAIN = [IDX.R_EAR, IDX.R_SHO, IDX.R_HIP, IDX.R_ANK] as const;

function isLandmarkVisible(p: Landmark | undefined, visibilityThreshold: number): boolean {
  if (!p) return false;
  return (p.visibility ?? 0) > visibilityThreshold;
}

function sideChainReady(
  landmarks: Landmark[],
  chain: readonly number[],
  visibilityThreshold: number
): boolean {
  return chain.every((idx) => isLandmarkVisible(landmarks[idx], visibilityThreshold));
}

/**
 * True when at least one full lateral chain (ear → shoulder → hip → ankle) is visible
 * above the threshold on the left OR right side. Used to gate posture auto-capture (#7239).
 */
export function hasMinimumLateralChainForCapture(
  landmarks: Landmark[] | null,
  visibilityThreshold: number
): boolean {
  if (!landmarks || landmarks.length === 0) return false;
  return (
    sideChainReady(landmarks, LEFT_CHAIN, visibilityThreshold) ||
    sideChainReady(landmarks, RIGHT_CHAIN, visibilityThreshold)
  );
}
